function e(e){return e!=null}export{e as isNonNullish};
//# sourceMappingURL=isNonNullish-DaUZVD22.js.map